import React from 'react';

// 演習の進み具合を示すタブ（問N-M）。Shape・Gaze で同じものを使う。
// 到達済みのステップには戻れる（回答済みなら当時の着色・選択が復元表示され、
// 決定ボタンだけが押せない状態になる）。回答済みは「✓」付きで見分けられるようにする。
export default function ExerciseTabs({
  totalSteps,
  stepsPerQuestion,
  index,
  canGoToIndex,
  isStepCompleted,
  onSelect,
}) {
  return (
    <div className="tabs mb-6">
      <div className="tabs-inner">
        {Array.from({ length: totalSteps }, (_, i) => {
          const question = Math.floor(i / stepsPerQuestion) + 1;
          const step = (i % stepsPerQuestion) + 1;
          const done = isStepCompleted(i);
          return (
            <button
              key={i}
              className={`tab ${i === index ? 'tab--active' : ''} ${done ? 'tab--done' : ''}`}
              onClick={() => onSelect(i)}
              disabled={!canGoToIndex(i)}
              title={done ? '回答済み（見直しのみ）' : undefined}
            >
              {done ? `✓ 問${question}-${step}` : `問${question}-${step}`}
            </button>
          );
        })}
      </div>
    </div>
  );
}
